import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import Validator from "validatorjs";
import { request as xhr, queryString as qs } from "../utils/request";
import { AppContext } from "../utils/context";
import { appEnv } from "../utils/constants";

import CheckoutSteps from "../components/CheckoutSteps";
import CheckoutTickets from "../components/CheckoutTickets";
import CheckoutSummary from "../components/CheckoutSummary";
import CheckoutPersonalInfo from "../components/CheckoutPersonalInfo";
import CheckoutVerify from "../components/CheckoutVerify";
import CheckoutThankYou from "../components/CheckoutThankYou";
import CheckoutProcessing from "../components/CheckoutProcessing";
import CheckoutError from "../components/CheckoutError";
import CheckoutEnvelope from "../components/CheckoutEnvelope";
import {
  browserName,
  fullBrowserVersion,
  osName,
  osVersion,
  isMobile,
  mobileVendor,
  mobileModel,
  deviceDetect
} from "react-device-detect";
import classnames from 'classnames';

class Checkout extends Component {
  constructor(props, context) {
    super(props);
    this.state = {
      loading: true,
      activeIndex: 1,
      activeSteps: [1],
      cartTotal: 0,
      cart: [],
      envelope: 0,
      beneficiaryId: 0,
      event: context.event,
      eventSubscribe: false,
      paysafe_status: true,
      paysafe_after_payclick: false,
      tickets_error: false,
      envelope_error: false,
      personal_info_error: false,
      paymentError: false,
      validation: new Validator({}, {}),
      error: {
        code: 0,
        message: "",
        action: "default"
      },
      payment: {
        payToken: '',
        recurring: 0
      },
      order: {
        id: 0,
        hash: "",
        orderstatus: 0,
        error: null
      },
      personal: {
        id: 0,
        first_name: "",
        last_name: "",
        title: "",
        email: "",
        email_confirmation: "",
        phone: "",
        phone_home: "",
        phone_work: "",
        address: "",
        suite: "",
        city: "",
        state: "",
        country: context.settings.country || "USA",
        zip_code: "",
        latitude: "",
        longitude: "",
        age_range: "",
        showRecipientForm: 0,
        recipientCount: 0,
        recipientList: [],
        subscribe: [
          {
            text: context.language.en.checkout_subscribe_sms,
            value: "text",
            checked: +context.settings.checkout_subscribe_sms > 0 ? true : false
          },
          {
            text: context.language.en.checkout_subscribe_email,
            value: "email",
            checked: +context.settings.checkout_subscribe_email > 0 ? true : false
          }
        ],
        agreement: [
          {
            text: context.language.en.checkout_agreement_age,
            value: "oldenough",
            checked: 0
          },
          {
            text: context.language.en.checkout_agreement_rules,
            value: "rules",
            checked: 0
          }
        ],
        saveInfo: [
          {
            text: "Save my personal information for my next visit",
            value: "saveinfo",
            checked: true
          }
        ]
      },
      invalidEmailError: null
    };
  }

  componentDidMount = () => {
    const { history } = this.props;
    let queryString = qs.parse(this.props.location.search);
    if (history.location.pathname.indexOf("/thank-you") > -1 && typeof (queryString.orderId) === "undefined") {
      history.push("/select-tickets");
    }
    this.setState(
      {
        order: {
          id: queryString.orderId ? queryString.orderId : 0,
          hash: queryString.hash ? queryString.hash : 0
        }
      },
      () => this.handleCallback()
    );
  };
  handleCallback = () => {
    const { history } = this.props;
    let queryString = qs.parse(this.props.location.search);
    if (history.location.pathname.indexOf("/thank-you") > -1 && typeof (queryString.orderId) !== "undefined" && typeof (queryString.hash) !== "undefined") {
      this.getOrder();
    } else {
      this.setup();
    }
  }
  componentWillUnmount = () => {
    const { cookies } = this.props;
    cookies.remove("order");
    cookies.remove("cart");
    cookies.remove("envelope");
  };
  loadPaysafe = () => {
    const script = document.createElement("script");
    script.src =
      "https://hosted.paysafe.com/checkout/v1/latest/paysafe.checkout.min.js";
    script.async = true;
    script.onload = () => {
      this.setState({
        loading: false
      });
    };
    document.body.appendChild(script);
  };
  geofenceError = () => {
    var error = { ...this.state.error };
    error.code = 2;
    error.message = "Geofence Error: Provided location out of geofence bounds";
    this.setState({ error });
  }
  checkMaxMind = () => {
    const script = document.createElement("script");
    script.src = "https://geoip-js.com/js/apis/geoip2/v2.1/geoip2.js";
    script.async = true;
    script.onload = () => {
      this.setState({
        loading: false
      });
      window.geoip2.city(this.mmSuccess, this.mmError);
    };
    document.body.appendChild(script);
  };
  initPaysafe = () => {
    const { cartTotal, personal } = this.state;
    this.setState({ paysafe_status: true });
    let self = this;

    // Get country ISO name
    let isoCountryCode = "";
    switch (personal.country) {
      case "CAN": 
        isoCountryCode = "CA";
        break;
      case "USA":
        isoCountryCode = "US";
        break;
    }

    let paysafeEncoded = this.context.settings.payment_auth;
    let paysafeRequest = {
      amount: cartTotal * 100,
      currency: this.context.settings.currency,
      environment: (this.context.settings.payment_paysafe_env === "production") ? "LIVE" : "TEST",
      companyName: this.context.settings.client_name,
      billingAddress: {
        country: isoCountryCode,
        zip: personal.zip_code,
        state: personal.state,
        city: personal.city,
        street: personal.address,
        street2: personal.suite
      }
    };

    if (appEnv === "production")
      this.context.settings.paysafe_logo !== "" ? paysafeRequest.imageUrl = this.context.settings.paysafe_logo : paysafeRequest.imageUrl = this.context.settings.header_logo;

    window.paysafe.checkout.setup(
      paysafeEncoded,
      paysafeRequest,
      function (instance, error, result) {
        if (error) {

          let errorObj = {
            "code": error.code,
            "message": error.displayMessage
          }

          self.setState(prevState => ({
            paymentError: true,
            error: errorObj,
            payment: errorObj,
          }));
          self.saveOrder();

          return false;

        }
        if (result.token) {

          if (result.paymentMethod === "Cards") {
            let payment = { ...self.state.payment };
            payment.payToken = result.token;
            self.setState({ payment: payment }, () => self.processOrder());
          }

          if (result.paymentMethod === "DirectDebit") {
            // use AJAX to send result.token to your merchant server to take DD payment
          }

          if (result.paymentMethod === "Interac") {
            // use AJAX to send result.token to your merchant server to take Interac payment
          }
          instance.close();
          self.setState({ paysafe_after_payclick: true });
        }
      },
      function (stage) {
        if (stage === "BeforePayment") {
          // No payment have been made
          // self.lastStep();
          self.cancelPayment();
        } else if (stage === "DuringPayment") {
          // Token have been issued, but the checkout overlay was closed from the user before instance flow control method was invoked
        } else if (stage === "AfterPayment") {
          // Closed either via instance.close method or by the user from the success screen

        }
      }
    );
  };

  getOrder() {
    const { order, event } = this.state;
    if (+order.id > 0) {
      return xhr
        .get(`api:/web/order/${order.id}`, {})
        .catch(err => {
          var error = { ...this.state.error };
          error.code = 10;
          error.message = err.message;
          error.action = "return";
          this.setState({ error });
          return err;
        })
        .then(resp => {
          if (+resp.id > 0) {
            let prices = event.prices;
            let ticketData = resp.ticketdata;
            let orderData = resp.orderdata;
            let envelope = resp.envelope;
            let cart = [];

            Object.keys(ticketData).map((v, k) => {
              let filteredPrice = prices.filter(function (pp) { if (pp['quantity'] === parseInt(v)) return pp['price'] !== ""; });
              return cart.push({
                tickets: v,
                cost: filteredPrice && filteredPrice.length > 0 ? filteredPrice[0].price : null,
                qty: ticketData[v] ? ticketData[v] : 0
              });
            });
            order['orderstatus'] = resp.orderstatus;
            order['error'] = resp.paymentdata && resp.paymentdata.error && resp.paymentdata.error.message ? resp.paymentdata.error.message : null;

            this.setState({
              loading: false,
              order: order,
              personal: orderData,
              cart: cart,
              envelope: +envelope,
              cartTotal: resp.totalcost
            });
          }
          return resp;
        });
    }
  }
  ValidateLocationSingle = (geoData, position) => {
    let self = this;

    var latTolerance = 0.01;
    var longTolerance = 0.01;

    // Check if within bounds and tolerance
    let isOutsideBounds = position.coords.latitude > geoData.border.n + latTolerance ||
      position.coords.latitude < geoData.border.s - latTolerance ||
      position.coords.longitude < geoData.border.w - longTolerance ||
      position.coords.longitude > geoData.border.e + longTolerance;

    if (isOutsideBounds) {
      this.geofenceError();
    }

    //If we reached here, they are within the bounds and within tolerance.  Align them to a resolution lookup to the geo data
    var xRes = (geoData.res - 1) / (geoData.border.e - geoData.border.w)
    var yRes = (geoData.res - 1) / (geoData.border.n - geoData.border.s)
    var xLookup = Math.floor((position.coords.longitude - geoData.border.w) * xRes)
    var yLookup = Math.floor((geoData.res - 1) - ((position.coords.latitude - geoData.border.s) * yRes))  //This one gets inverted to align with bitmap data

    //Because we allow for tolerance we need to ensure the numbers properly align to index space
    if (xLookup < 0) { xLookup = 0; }
    if (xLookup >= geoData.Res) { xLookup = geoData.res - 1; }
    if (yLookup < 0) { yLookup = 0; }
    if (yLookup >= geoData.Res) { yLookup = geoData.res - 1; }

    //Use the lookups to test the geo data if the location is within borders or not
    //The geo data is set as an array of hex data, each element in the array is a row in the map
    //Each row is a hex string representing the bits in that map

    var geoRowData = geoData.data[yLookup];

    if (geoData.compression == "True")
      geoRowData = self.DecompressRow(geoRowData);

    //There are 4 bits per character, find the character
    var geoElementIndex = Math.floor(xLookup / 4)
    var geoElementBitMask = 1 << (xLookup - (geoElementIndex * 4))
    var geoElementCharacter = geoRowData.charAt(geoElementIndex)
    var geoHex = parseInt(geoElementCharacter, 16);

    //Test if the bit mask is within the hex data, if so this location is on the map
    if ((geoElementBitMask & geoHex) == geoElementBitMask) {
      return true;
    }
    else {
      this.geofenceError();
    }
  }
  ValidateLocationArray = (geoData, position) => {
    let self = this;

    var latTolerance = 0.01;
    var longTolerance = 0.01;
    var geoDataLocal = geoData;
    var found = 0;

    for (var i = 0; i < geoDataLocal.length && found == 0; i++) {

      if (position.coords.latitude < geoDataLocal[i].border.n + latTolerance &&
        position.coords.latitude > geoDataLocal[i].border.s - latTolerance &&
        position.coords.longitude > geoDataLocal[i].border.w - longTolerance &&
        position.coords.longitude < geoDataLocal[i].border.e + longTolerance) {
        found = 1;
      }

      //this only means that the position was found within the bounding box for the province, 
      // there can be overlap between the province's bounding boxes so need to check further
      if (found == 1) {

        var foundBoundary = i;//where we broke out

        //If we reached here, they are within a bounds and within tolerance.  Align them to a resolution lookup to the geo data
        var xRes = (geoDataLocal[foundBoundary].res - 1) / (geoDataLocal[foundBoundary].border.e - geoDataLocal[foundBoundary].border.w)
        var yRes = (geoDataLocal[foundBoundary].res - 1) / (geoDataLocal[foundBoundary].border.n - geoDataLocal[foundBoundary].border.s)
        var xLookup = Math.floor((position.coords.longitude - geoDataLocal[foundBoundary].border.w) * xRes)
        var yLookup = Math.floor((geoDataLocal[foundBoundary].res - 1) - ((position.coords.latitude - geoDataLocal[foundBoundary].border.s) * yRes))  //This one gets inverted to align with bitmap data

        //Because we allow for tolerance we need to ensure the numbers properly align to index space
        if (xLookup < 0) { xLookup = 0; }
        if (xLookup >= geoDataLocal[foundBoundary].Res) { xLookup = geoDataLocal[foundBoundary].res - 1; }
        if (yLookup < 0) { yLookup = 0; }
        if (yLookup >= geoDataLocal[foundBoundary].Res) { yLookup = geoDataLocal[foundBoundary].res - 1; }

        //Use the lookups to test the geo data if the location is within borders or not
        //The geo data is set as an array of hex data, each element in the array is a row in the map
        //Each row is a hex string representing the bits in that map                  

        var geoRowData = geoDataLocal[foundBoundary].data[yLookup];

        if (geoDataLocal[foundBoundary].compression == "True")
          geoRowData = self.DecompressRow(geoRowData);

        //There are 4 bits per character, find the character
        var geoElementIndex = Math.floor(xLookup / 4)
        var geoElementBitMask = 1 << (xLookup - (geoElementIndex * 4))
        var geoElementCharacter = geoRowData.charAt(geoElementIndex)
        var geoHex = parseInt(geoElementCharacter, 16);

        //Test if the bit mask is within the hex data, if so this location is on the map
        if ((geoElementBitMask & geoHex) == geoElementBitMask) {
          return true;
        }
        else {
          //this was within the province's bounding box but not in the province
          found = 0;
        }
      }//if found
    }//loop

    if (found == 0) {
      this.geofenceError();
    }
  }
  DecompressRow = (rowData) => {
    //&16-080ff01&42-0 - form of rowData

    var outputRow = "";

    for (var i = 0; i < rowData.length; i++) {
      var myChar = rowData[i];

      if (myChar == "&") {
        var startPos = i + 1;
        var endPos = rowData.indexOf("-", startPos);
        i = endPos + 1;

        var numberOfRepeats = rowData.substring(startPos, endPos);
        var repeatingChar = rowData[i];

        //add the repeatingChar 
        for (var j = 0; j < parseInt(numberOfRepeats); j++) {
          outputRow += repeatingChar;
        }
      }
      else {
        outputRow += rowData[i];
      }
    }

    return outputRow;
  }
  setup = () => {
    this.loadPaysafe();
    let self = this;
    const { event } = this.state;
    const { settings } = this.context;
    const { cookies, history } = this.props;

    // redirect '/select-tickets' to homepage if event.shopify_enabled
    if (+event.shopify_enabled === 1 && this.props.location.pathname === "/select-tickets") {
      window.location.href = "/";
    }

    let promise = Promise.resolve(true);
    if (
      settings.bitmask_url !== "" ||
      settings.web_geofence_state !== "" ||
      settings.web_geofence_country !== ""
    ) {
      promise = self.getPosition();
    }

    promise.then(success => {
      if (success === true) {
        return self.getOrder();
      }
    })
      .then(resp => {
        if (resp.id) {
          if (resp.orderstatus === 1) {
            cookies.remove('order');
            history.replace();
            history.replace(`/thank-you?orderId=${resp.id}&hash=${resp.orderhash}`);
            return Promise.reject('Order has already processed');
          }
        }
        return true;
      })
      .catch(err => {
        return false;
      })
      .then(resp => {
        let prices = event.prices;
        let loadCart = [];
        const { state } = this.props.location;
        if (prices) {
          Object.keys(prices).map((v, k) => {
            return loadCart.push({
              tickets: prices[v].quantity,
              cost: prices[v].price,
              qty: state ? (state.pricePointKey === k ? 1 : 0) : 0,
              disabled: prices[v].disabled
            });
          });
        }
        let loadPersonal = { ...this.state.personal };
        if (appEnv === "development") {
          loadPersonal["first_name"] = "Matt";
          loadPersonal["last_name"] = "annis";
          loadPersonal["email"] = "mannis@bumpcbn.com";
          loadPersonal["email_confirm"] = "mannis@bumpcbn.com";
          loadPersonal["phone"] = "6138971491";
          loadPersonal["phone_home"] = "";
          loadPersonal["phone_work"] = "";
          loadPersonal["address"] = "250 The Esplanade";
          loadPersonal["suite"] = "206";
          loadPersonal["city"] = "Toronto";
          loadPersonal["state"] = "ON";
          loadPersonal["zip_code"] = "M5A 4J6";
        }

        const { cookies } = this.props;
        const personalInfo = cookies.get("personal");
        const cart = cookies.get("cart");
        // const order = cookies.get("order");
        const envelope = cookies.get("envelope");
        if (personalInfo) {
          loadPersonal = personalInfo;
        }
        if (cart) {
          loadCart = cart;
        }
        let callback = this.calculate;
        if (history.location.pathname.indexOf("/process-order") > -1) callback = this.processOrder;
        if (history.location.pathname.indexOf("/thank-you") > -1) callback = this.getOrder;
        // this call can result in 2 instances of select-tickets being on the browser stack but ok with that since
        // it results in preventing browser forward navigation from home screen past the select Ticket screen in most cases
        if (!cart) {
          history.push("/select-tickets");
        } else if (event.game.id === 3 && !envelope) {
          // in this case if we are currently on the pick-envelope screen do not push it pnto the browser stack again
          if (history.location.pathname.indexOf("/pick-envelope") < 0) {
            history.push("/pick-envelope");
          }
        }
        this.setState(
          {
            loading: false,
            cart: loadCart,
            personal: loadPersonal,
            envelope: +envelope
          },
          callback
        );
        
      });
  };
  getPosition = async () => {
    let self = this;
    const { settings } = this.context;

    const geoData = await fetch(`${settings.bitmask_url}`, {}).then(response => response.text()).catch(err => {
      this.geofenceError();
    }).then(text => {
      let data = JSON.parse(text.replace("var geoData = ", '').replace(/[a-z]+:/gi, function (x) {
        return '"' + x.replace(":", "") + '":';
      }));
      return data;
    });

    return new Promise(function (resolve, reject) {
      navigator.geolocation.getCurrentPosition(resolve, reject, {
        timeout: 5000
      });
    })
      .then(position => {
        if (position === "ignore") return "ignore";
        let personal = { ...self.state.personal };
        personal["latitude"] = position.coords.latitude;
        personal["longitude"] = position.coords.longitude;
        this.setState({ personal });
        return position.coords;
      })
      .catch(err => {
        if (settings.maxmind_enabled) {
          this.checkMaxMind();
          return "ignore";
        }

        let message = "";
        switch (err.code) {
          case err.PERMISSION_DENIED:
            message =
              "You must allow your browser to share your location to purchase tickets. Please enable location services for this browser and try again.";
            break;
          case err.POSITION_UNAVAILABLE:
            message = "Location information is unavailable. In order to purchase tickets your location must be able to be determined. Please enable location services for this browser and try again.";
            break;
          case err.TIMEOUT:
            message = "The request to get user location timed out. In order to purchase tickets your location must be able to be determined. Please enable location services for this browser and try again.";
            break;
          default:
            message =
              "An unknown error occurred while attempting to determine your location... In order to purchase tickets your location must be able to be determined. Please enable location services for this browser and try again.";
        }
        var error = { ...this.state.error };
        error.code = err.code;
        error.message = message;
        error.action = "default";
        this.setState({ error });
        return false;
      })
      .then(coords => {
        if (coords === false) {
          return false;
        }
        if (coords === "ignore") {
          return "ignore";
        }

        // let payload = {
        //   latitude: coords.latitude,
        //   longitude: coords.longitude
        // };

        // return xhr.post("api:/web/geofence", payload);

        let position = {
          coords: {
            latitude: coords.latitude,
            longitude: coords.longitude
          }
        };

        // Ensure in proper state to validate location
        let dataIsInvalid = position == null || geoData == null;
        if (dataIsInvalid) {
          this.geofenceError();
        }

        // Validate location
        if (geoData.constructor === Array) {
          self.ValidateLocationArray(geoData, position);
        }
        else {
          self.ValidateLocationSingle(geoData, position);
        }
      })

    // .then(resp => {
    //   if (resp === "ignore") return true;
    //   if (resp.success && resp.success === true) {
    //     return resp.message;
    //   } else {
    //     var error = { ...this.state.error };
    //     error.code = 2;

    //     if (resp && resp.message) {
    //       error.message = resp.message;
    //     }

    //     this.setState({ error });
    //     return false;
    //   }
    // });
  };

  mmSuccess = position => {
    const { settings } = this.context;

    if ((settings.web_geofence_country != '' && settings.web_geofence_country.toLowerCase() != position.country.names.en.toLowerCase())
      || (settings.web_geofence_state != '' && settings.web_geofence_state.toLowerCase() != position.subdivisions['0'].names.en.toLowerCase())) {
      return this.mmError();
    }

    // Position verified
    return position;
  };

  mmError = error_message => {
    var error = { ...this.state.error };
    error.code = "-1";
    error.message = "An unknown error occurred while attempting to determine your location... In order to purchase tickets your location must be able to be determined. Please enable location services for this browser and try again.";
    error.action = "default";
    this.setState({ error });
    return false;
  };

  checkout = (recaptcha) => {
    let self = this;
    const { cookies } = this.props;
    this.saveCart();
    this.saveOrder(recaptcha).catch(function (err) {
      return err;
    }).then(function (resp) {
      self.setState({ order: resp.data });
      cookies.set('order', resp.data);
    });
  };
  processOrder = () => {
    let self = this;

    const { cookies, history } = this.props;
    let payToken = self.state.payment.payToken;
    let order = self.state.order;
    let event = self.state.event;


    return xhr.post(`api:/web/order/${order.id}/process`, {
      payToken: payToken,
      id: order.id,
      orderToken: order.ordertoken,
      eventId: event.id,
      hash: order.hash
    }).then(resp => {
      let order = this.state.order;
      if (!resp || resp.status === 'error') {
        let error = {
          "code": 0,
          "message": resp.message ? resp.message : "There was a problem processing your order"
        }
        this.setState({ error: error });
      } else if (resp === 401) {
        let error = {
          "code": 0,
          "message": "There was a problem processing your order"
        }
        this.setState({ error: error });
      }
      else if (resp.status === 'success') {
        setTimeout(() => {
          self.getOrder().then(resp => {
            if (resp.id && (+resp.orderstatus === 0 || +resp.orderstatus === 1 || +resp.orderstatus === 2)) {
              history.replace();
              history.replace(`/thank-you?orderId=${order.id}&hash=${order.hash}`);
            } else {
              let error = {
                "code": 0,
                "message": "There was a problem processing your order"
              }
              if (resp.paymentdata && resp.paymentdata.error) {
                error.code = resp.paymentdata.error.code ? resp.paymentdata.error.code : error.code;
                error.message = resp.paymentdata.error.message ? resp.paymentdata.error.message : error.message;
              }
              this.setState({ error: error });
            }
            cookies.remove('order');
            cookies.remove("cart");
            cookies.remove("envelope");
            cookies.remove("personal");
          })
        }, 5000);
        return false;
      } else {
        // fall through lets set an error code for this particular fall through
        let error = {
          "code": 2,
          "message": resp.message ? resp.message : "There was a problem processing your order, error code 2"
        }
        this.setState({ error: error });
      }
      return resp;
    });
  };

  saveCart = () => {
    const { cookies } = this.props;

    const { personal, cart, order } = this.state;
    if (personal.saveInfo[0].checked) cookies.set("personal", personal);
    cookies.set("order", order);
    cookies.set("cart", cart);
    return true;
  };
  savePersonal = () => {
    this.saveCart();
    const { personal } = this.state;
    let payload = personal;

    return xhr.post("api:/web/save-personal", payload).then(resp => {
      let personal = { ...this.state.personal };
      personal["id"] = resp.customer.id;
      this.setState({ personal });
      return resp;
    });
  };
  saveOrder = (recaptcha) => {
    this.saveCart();
    const { event, personal, order, cart, cartTotal, payment, envelope, beneficiaryId } = this.state;

    let payload = {
      eventId: event.id,
      personal: personal,
      order: order,
      cart: cart,
      total: cartTotal,
      payment: payment,
      envelope: envelope,
      beneficiaryId: beneficiaryId,
      platform: {
        browserName: browserName,
        fullBrowserVersion: fullBrowserVersion,
        osName: osName,
        osVersion: osVersion,
        isMobile: isMobile,
        mobileVendor: mobileVendor,
        mobileModel: mobileModel,
        deviceDetect: deviceDetect()
      },
      recaptcha: recaptcha
    };

    let result;
    if (order.id > 0) {
      result = xhr.put(`api:/web/order/${order.id}`, payload);
    } else {
      result = xhr.post("api:/web/order", payload)
    }

    return result;
  };
  startPayment = () => {
    this.saveCart();
    const { event, personal, order } = this.state;
    let payload = {
      eventId: event.id,
      orderId: order.id,
      customerId: personal.id
    };

    return xhr.post("api:/web/init-payment", payload).then(resp => {
      return resp;
    });
  };
  handleCart = e => {
    let cart = [...this.state.cart];
    let key = e.target.id.replace("cart-", "");
    let val = e.target.value;
    if (val >= 10) val = 10;
    if (val < 0) val = 0;
    cart[key].qty = val;
    this.setState({ cart, tickets_error: false }, this.calculate);
  };
  handleEnvelope = e => {
    const { cookies } = this.props;
    cookies.set("envelope", e.currentTarget.getAttribute('data-index'));
    this.setState({ envelope: +e.currentTarget.getAttribute('data-index'), envelope_error: false });
  };
  handleBeneficiary = (e) => {
    const { value } = e;
    this.setState({ beneficiaryId: value });
  }
  handleChange = e => {
    let { name, value } = e.target;
    let personal = { ...this.state.personal };
    personal[name] = value;
    this.setState({ personal });
  };
  handlePhoneNumber = e => {
    let { name, value } = e.target;
    value = value.replace(/\D/g, "");
    let personal = { ...this.state.personal };
    personal[name] = value;
    this.setState({ personal });
  }
  handleGiftTicket = e => {
    let personal = { ...this.state.personal };
    personal.showRecipientForm = e.target.checked === true ? 1 : 0;
    this.setState({ personal });
  };
  handleSubscribe = e => {
    let { value, checked } = e.target;
    let personal = { ...this.state.personal };
    let subscribe = personal.subscribe;
    subscribe.forEach(sub => {
      if (sub.value === value) sub.checked = checked;
    });
    personal["subscribe"] = subscribe;
    this.setState({ personal });
  };
  handleAgreement = e => {
    let { value, checked } = e.target;
    let personal = { ...this.state.personal };
    let agreement = personal.agreement;
    agreement.forEach(agree => {
      if (agree.value === value) agree.checked = checked;
    });
    personal["agreement"] = agreement;
    this.setState({ personal });
  };
  handleEventSubscription = e => {
    let payment = { ...this.state.payment };
    payment.recurring = e.target.checked === true ? 1 : 0;
    this.setState({ payment });
  };
  handleSaveInfo = e => {
    let { value, checked } = e.target;
    let personal = { ...this.state.personal };
    let saveInfo = personal.saveInfo;
    saveInfo.forEach(info => {
      if (info.value === value) info.checked = checked;
    });
    personal["saveInfo"] = saveInfo;
    this.setState({ personal });
  };
  calculate = () => {
    let cart = this.state.cart;
    let total = 0;
    cart.map(c => {
      return (total += c.qty * c.cost);
    });
    this.setState({ cartTotal: total });
  };
  validateCart = () => {
    this.saveCart();
    const { history } = this.props;
    const { event } = this.state;
    const rules = {
      cartTotal: "min:1"
    };
    const customMessages = {
      "min.cartTotal": "Please select tickets to continue",
    };
    let validation = new Validator(this.state, rules, customMessages);

    if (validation.passes()) {
      event.game.id === 3 ? history.push("/pick-envelope") : history.push("/personal-info");
    } else {
      this.setState({ validation, tickets_error: true });
    }
  };
  validateCartFinal = () => {
    this.saveCart();
    const { history } = this.props;
    const rules = {
      cartTotal: "min:1",
      envelope: "min:1"
    };
    const customMessages = {
      "min.envelope": "Please pick an envelope to continue"
    };
    let validation = new Validator(this.state, rules, customMessages);

    if (validation.passes()) {
      history.push("/personal-info");
    } else {
      this.setState({ validation, envelope_error: true, tickets_error: true });
    }
  };
  validateCartTickets = () => {
    this.saveCart();
    const { history } = this.props;
    const rules = {
      cartTotal: "min:1"
    };
    let validation = new Validator(this.state, rules);

    if (validation.passes()) {
      history.push("/personal-info");
    } else {
      this.setState({ validation });
    }
  };
  handleStateRecipientCount = (count, list) => {
    document.getElementById('recipientLimit').value = count;
    let personal = this.state.personal;
    personal.recipientCount = count;
    personal.recipientList = list;
    this.setState(personal);
  }
  validateRecipientList = () => {
    let list = this.state.personal.recipientList;
    let filteredList = list.filter(function (e) { return e['recipientListEmail'] !== ""; });
    this.handleStateRecipientCount(filteredList.length, filteredList);
  }
  emailValidation = (email) => {
    const regex = /^[-!#-'*+\/-9=?^-~]+(?:\.[-!#-'*+\/-9=?^-~]+)*@[-!#-'*+\/-9=?^-~]+(?:\.[-!#-'*+\/-9=?^-~]+)+$/i;
    if (regex.test(email)) {
      return true;
    }
    else {
      return false;
    }
  }
  validatePersonal = () => {
    this.saveCart();
    const { history } = this.props;
    const { settings } = this.context;
    const { personal } = this.state;
    const rules = {
      "first_name": "required|string",
      "last_name": "required|string",
      "email": "required|email|confirmed",
      "email_confirmation": "required|email",
      "phone": "required|digits:10",
      "address": "required|string",
      "city": "required|string",
      "country": "required|string",
      "state": "required|string",
      "zip_code": "required|string",
      "agreement.0.checked": "accepted",
      "agreement.1.checked": "accepted",
      "recipientList.*.recipientListFirstName": +settings.giftingOption > 0 && personal.showRecipientForm > 0 && "required|string",
      "recipientList.*.recipientListLastName": +settings.giftingOption > 0 && personal.showRecipientForm > 0 && "required|string",
      "recipientList.*.recipientListEmail": +settings.giftingOption > 0 && personal.showRecipientForm > 0 && "required|email",
      "recipientList.*.recipientListEmailConfirmation": +settings.giftingOption > 0 && personal.showRecipientForm > 0 && "required|email"
    };
    const customMessages = {
      "accepted.agreement.0.checked": "This field is required",
      "accepted.agreement.1.checked": "This field is required"
    };

    let personalAgreement = this.state.personal.agreement;
    personalAgreement.forEach((agreement, key) => {
      if(agreement.text === "") {
        delete rules[`agreement.${key}.checked`];
      }
    });
    let validation = new Validator(this.state.personal, rules, customMessages);
    if (validation.passes()) {
      if (this.emailValidation(personal.email)) {
        if (+settings.giftingOption > 0 && +personal.showRecipientForm > 0) {
          this.validateRecipientList();
        }
        history.push("/confirm-order");
        this.setState({ personal_info_error: false, invalidEmailError: null });
      } else {
        this.setState({ personal_info_error: true, invalidEmailError: "The email format is invalid" });
      }
    }
    this.setState({ validation });
  };
  validateConfirm = (recaptcha) => {

    this.setState({ isProcessLoading: true });
    this.saveCart();

    let currentEvent = this.state.event;
    const { history } = this.props;
    const rules = currentEvent.game.id === 3 ? {
      envelope: "min:1",
      cartTotal: "min:1"
    } : {
      cartTotal: "min:1"
    };
    let validation = new Validator(this.state, rules);

    // verify that selected pricepoint is still an option
    let prices = currentEvent.prices;
    let pricepointMismatch = false;
    xhr.get(`api:/web/event/${currentEvent.id}`, {})
      .catch(err => {
        var error = { ...this.state.error };
        error.code = 10;
        error.message = err.message;
        error.action = "return";
        this.setState({ error });
        return err;
      })
      .then(resp => {
        if (resp.web_sales_paused) {
          var error = { ...this.state.error };
          error.code = 10;
          error.message = "E-Commerce sales are currently paused, please try again later.";
          error.action = "return";
          this.setState({ error });
          return error;
        } else if (+resp.id > 0) {
          let currentPrices = resp.prices;

          if (JSON.stringify(prices) === JSON.stringify(currentPrices)) {
            pricepointMismatch = false;
          } else {
            pricepointMismatch = true;

            var error = { ...this.state.error };
            error.code = 10;
            error.message = "Selected Pricepoint is no longer available, please try again.";
            error.action = "return";
            this.setState({ error });
            return error;
          }
        }
      });

    var self = this;
    setTimeout(function () {
      if (validation.passes() && !pricepointMismatch) {
        history.push('/payment-info');
        self.checkout();
      } else {
        self.setState({ validation, personal_info_error: true, isProcessLoading: false });
      }
    }, 1000); // slight delay to handle race condition with rendering child-component
  }

  cancelPayment = () => {
    let paysafe_status = false;
    this.setState({ paysafe_status });
  };
  goToPrevious = () => {
    const { event } = this.state;
    switch (this.props.location.pathname) {
      case "/payment-info":
        this.props.history.push("/confirm-order");
        break;
      case "/confirm-order":
        this.props.history.push("/personal-info");
        break;
      case "/personal-info":
        event.game.id === 3 ? this.props.history.push("/pick-envelope") : this.props.history.push("/select-tickets");
        break;
      case "/pick-envelope":
        this.props.history.push("/select-tickets");
        break;
      case "/select-tickets":
        this.props.history.push("/");
        break;
      default:
        this.props.history.push("/select-tickets");
    }
  };
  getEnvelopeHeight = (url) => {
    let image = new Image();
    image.src = url;
    let height = image.height > 640 ? 640 : image.height;
    return height;
  }

  render() {
    const {
      cart,
      cartTotal,
      error,
      event,
      order,
      personal,
      validation,
      envelope,
      payment,
      paysafe_status,
      paysafe_after_payclick,
      loading
    } = this.state;
    const { settings, language } = this.context;
    const { pathname: path } = this.props.location;
    let envelopeBackgroundImageHeight = this.getEnvelopeHeight(settings.envelope_background_image);

    const heroBoxClasnames = classnames('container', 'content', 'm-auto', { 'box-it': +settings.checkout_box_highlighting === 1 })

    let steps = [];
    this.context.event.game.id === 3 ?
      steps = [
        {
          active: path === "/select-tickets" ? true : false,
          title: "Select Tickets"
        },
        {
          active: path === "/pick-envelope" ? true : false,
          title: "Pick Envelope"
        },
        {
          active: path === "/personal-info" ? true : false,
          title: "Personal Info"
        },
        {
          active: path === "/confirm-order" ? true : false,
          title: "Review Order"
        },
        {
          active: (path === "/payment-info" || path === "/process-order") ? true : false,
          title: "Payment Info"
        },
        {
          active: path === "/thank-you" ? true : false,
          title: "Print Tickets"
        }
      ]
      :
      steps = [
        {
          active: path === "/select-tickets" ? true : false,
          title: "Select Tickets"
        },
        {
          active: path === "/personal-info" ? true : false,
          title: "Personal Info"
        },
        {
          active: path === "/confirm-order" ? true : false,
          title: "Review Order"
        },
        {
          active: (path === "/payment-info" || path === "/process-order") ? true : false,
          title: "Payment Info"
        },
        {
          active: path === "/thank-you" ? true : false,
          title: "Print Tickets"
        }
      ];
    if (this.state.loading === true) return '';
    return (
      <div className=" mx-auto py-6 video-main video-bg" style={{ backgroundColor: settings.hero_background_color }}>
        <div className="video cover align-center align-middle">
          {settings.checkout_background_image && settings.checkout_background_image !== "" && (
            <img
              src={`${settings.checkout_background_image}`}
              alt=""
              className="opacity-75"
            />)
          }
        </div>
        <div className={heroBoxClasnames}>
          <h1 className="mb-6">Checkout</h1>
          {error.code > 0 || error.message !== "" ? (
            <CheckoutError error={error} order={order} event={event} language={language} />
          ) : (
            <div>
              <CheckoutSteps steps={steps} />
              <CheckoutSummary event={this.context.event} cart={cart} envelope={envelope} total={cartTotal} />
              <Switch>
                <Route
                  path="/select-tickets"
                  exact
                  render={props => (
                    <CheckoutTickets
                      context={this.context}
                      cart={cart}
                      handleCart={this.handleCart}
                      handleBeneficiary={this.handleBeneficiary}
                      validateCart={this.validateCart}
                      validateCartTickets={this.validateCartTickets}
                      valid={validation.errorCount > 0 ? validation.errors.errors : {}}
                      tickets_error={this.state.tickets_error}
                      goToPrevious={this.goToPrevious}
                      {...props}
                    />
                  )}
                />
                <Route
                  path="/pick-envelope"
                  exact
                  render={props => (
                    <CheckoutEnvelope
                      envelope={envelope}
                      envelopes={event.cards}
                      handleEnvelope={this.handleEnvelope}
                      validateCartFinal={this.validateCartFinal}
                      goToPrevious={this.goToPrevious}
                      envelope_error={this.state.envelope_error}
                      tickets_error={this.state.tickets_error}
                      valid={validation.errorCount > 0 ? validation.errors.errors : {}}
                      scripts_pick_envelope={settings.scripts_pick_envelope}
                      envelope_number_color={settings.envelope_number_color}
                      envelope_background_image={settings.envelope_background_image}
                      envelopeBackgroundImageHeight={envelopeBackgroundImageHeight < +settings.envelope_background_default_height ? +settings.envelope_background_default_height : envelopeBackgroundImageHeight}
                    />
                  )}
                />
                <Route
                  path="/personal-info"
                  exact
                  render={props => (
                    <CheckoutPersonalInfo
                      data={personal}
                      valid={
                        validation.errorCount > 0 ? validation.errors.errors : {}
                      }
                      settings={settings}
                      handleChange={this.handleChange}
                      handlePhoneNumber={this.handlePhoneNumber}
                      handleSubscribe={this.handleSubscribe}
                      handleGiftTicket={this.handleGiftTicket}
                      handleStateRecipientCount={this.handleStateRecipientCount}
                      handleAgreement={this.handleAgreement}
                      handleEventSubscription={this.handleEventSubscription}
                      handleSaveInfo={this.handleSaveInfo}
                      validatePersonal={this.validatePersonal}
                      event={this.context.event}
                      goToPrevious={this.goToPrevious}
                      payment={payment}
                      defaultCountry={settings.country}
                      giftingOption={settings.giftingOption}
                      recipientLimit={settings.recipientLimit}
                      invalidEmailError={this.state.invalidEmailError}
                      config = {this.context.config}
                      {...props}
                    />
                  )}
                />
                <Route
                  path="/confirm-order"
                  exact
                  render={props => <CheckoutVerify
                    orderRecaptchaRequired={this.context.config.option_require_recaptcha}
                    recaptchaKey={this.context.config.google_recaptcha_public_key}
                    recaptchaType={this.context.config.option_recaptcha_type}
                    settings={this.context.settings}
                    data={personal}
                    validateConfirm={this.validateConfirm}
                    payment={payment}
                    event={this.context.event}
                    personal_info_error={this.state.personal_info_error}
                    giftingOption={settings.giftingOption}
                    goToPrevious={this.goToPrevious}
                    {...props} />}
                />
                <Route
                  path="/payment-info"
                  exact
                  render={props => (<CheckoutProcessing
                    settings={this.context.settings}
                    title="Payment Information"
                    paysafe_after_payclick={paysafe_after_payclick}
                    initPaysafe={this.initPaysafe}
                    paysafe_status={paysafe_status}
                    goToPrevious={this.goToPrevious}
                    {...props}
                  />)
                  }
                />
                <Route
                  path="/process-order"
                  exact
                  render={props => (
                    <CheckoutProcessing
                      key={4}
                      title="Please wait"
                      content="Processing order..."
                      {...props}
                    />
                  )}
                />
                <Route
                  path="/thank-you"
                  exact
                  render={props => (
                    <CheckoutThankYou
                      order={order}
                      cart={cart}
                      cartTotal={cartTotal}
                      event={event}
                      personal={personal}
                      giftingOption={settings.giftingOption}
                      {...props}
                      settings={this.context.settings}
                      loading={loading}
                    />
                  )}
                />
              </Switch>
            </div>
          )}
        </div>
      </div>
    );
  }
}
Checkout.contextType = AppContext;

export default Checkout;
